import {
  DashboardOutlined,
  CalendarOutlined,
  DesktopOutlined,
  ProfileOutlined,
  SettingOutlined,
  UserOutlined,
  TeamOutlined,
  NotificationOutlined,
  PictureOutlined,
  ScheduleOutlined,
  DollarOutlined,
  WalletOutlined,
  BankOutlined,
  CloudServerOutlined,
  FolderOpenOutlined,
  BarChartOutlined,
  BookOutlined,
  UnorderedListOutlined,
  ControlOutlined,
  GlobalOutlined,
} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

// Resource constants (must match backend)
export const RESOURCES = {
  DASHBOARD: 'dashboard',
  EVENTS: 'events',
  JATHAS: 'jathas',
  PROGRAM_TYPES: 'program_types',
  SIKH_HOLIDAYS: 'sikh_holidays',
  MAINBOARD: 'mainboard',
  SCROLLBOARD: 'scrollboard',
  SLIDESHOW: 'slideshow',
  NOTICES: 'notices',
  USERS: 'users',
  // Finance resources
  EXPENSES: 'expenses',
  GOLAK: 'golak',
  DONATIONS: 'donations',
  // File management
  DOCUMENTS: 'documents',
  // Reports
  REPORTS: 'reports',
  // System resources
  BACKUPS: 'backups',
  // Gurbani resources
  HUKAMNAMA: 'hukamnama',
  PLAYLISTS: 'playlists',
  DISPLAY_CONTROL: 'display_control',
  // Website settings
  WEBSITE_SETTINGS: 'website_settings',
  // Gallery
  GALLERY: 'gallery',
};

// Display Control group - TV display related settings
const displayControlNavTree = [{
  key: 'display-control',
  path: `${APP_PREFIX_PATH}/sab`,
  title: 'Display Control',
  icon: DesktopOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'sab-dashboard',
      path: `${APP_PREFIX_PATH}/sab/dashboard`,
      title: 'Display Settings',
      icon: DashboardOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.DASHBOARD, action: 'read' }
    },
    {
      key: 'sab-mainboard',
      path: `${APP_PREFIX_PATH}/sab/mainboard`,
      title: 'Slideshow',
      icon: PictureOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.MAINBOARD, action: 'read' }
    },
    {
      key: 'sab-scrollboard',
      path: `${APP_PREFIX_PATH}/sab/scrollboard`,
      title: 'Scrollboard',
      icon: ProfileOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.SCROLLBOARD, action: 'read' }
    },
    {
      key: 'sab-notices',
      path: `${APP_PREFIX_PATH}/sab/notices`,
      title: 'Notice Board',
      icon: NotificationOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.NOTICES, action: 'read' }
    },
    {
      key: 'sab-display-remote',
      path: `${APP_PREFIX_PATH}/sab/display-remote`,
      title: 'Display Remote',
      icon: ControlOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.DISPLAY_CONTROL, action: 'read' }
    },
    {
      key: 'sab-hukamnama',
      path: `${APP_PREFIX_PATH}/sab/hukamnama`,
      title: 'Hukamnama Sahib',
      icon: BookOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.HUKAMNAMA, action: 'read' }
    },
    {
      key: 'sab-playlists',
      path: `${APP_PREFIX_PATH}/sab/playlists`,
      title: 'Shabad Playlists',
      icon: UnorderedListOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.PLAYLISTS, action: 'read' }
    },
  ]
}];

// Events group - Event and booking management
const eventsNavTree = [{
  key: 'events-management',
  path: `${APP_PREFIX_PATH}/sab`,
  title: 'Events',
  icon: CalendarOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'sab-events',
      path: `${APP_PREFIX_PATH}/sab/events`,
      title: 'Event Bookings',
      icon: CalendarOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.EVENTS, action: 'read' }
    },
    {
      key: 'sab-jathas',
      path: `${APP_PREFIX_PATH}/sab/jathas`,
      title: 'Jatha Management',
      icon: TeamOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.JATHAS, action: 'read' }
    },
    {
      key: 'sab-program-types',
      path: `${APP_PREFIX_PATH}/sab/program-types`,
      title: 'Program Types',
      icon: SettingOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.PROGRAM_TYPES, action: 'read' }
    },
    {
      key: 'sab-sikh-holidays',
      path: `${APP_PREFIX_PATH}/sab/sikh-holidays`,
      title: 'Sikh Events',
      icon: ScheduleOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.SIKH_HOLIDAYS, action: 'read' }
    },
    {
      key: 'sab-volunteers',
      path: `${APP_PREFIX_PATH}/sab/volunteers`,
      title: 'Nagar Kirtan Volunteers',
      icon: TeamOutlined,
      breadcrumb: false,
      submenu: [],
    },
  ]
}];

// Finances group - Accounting and donations
const financesNavTree = [{
  key: 'finances',
  path: `${APP_PREFIX_PATH}/sab`,
  title: 'Finances',
  icon: DollarOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'sab-reports',
      path: `${APP_PREFIX_PATH}/sab/reports`,
      title: 'Reports & Analytics',
      icon: BarChartOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.REPORTS, action: 'read' }
    },
    {
      key: 'sab-expenses',
      path: `${APP_PREFIX_PATH}/sab/expenses`,
      title: 'Expenses',
      icon: WalletOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.EXPENSES, action: 'read' }
    },
    {
      key: 'sab-golak',
      path: `${APP_PREFIX_PATH}/sab/golak`,
      title: 'Golak & Donations',
      icon: BankOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.GOLAK, action: 'read' }
    },
  ]
}];

// Administration group - User management
const adminNavTree = [{
  key: 'administration',
  path: `${APP_PREFIX_PATH}/sab`,
  title: 'Administration',
  icon: SettingOutlined,
  breadcrumb: false,
  isGroupTitle: true,
  submenu: [
    {
      key: 'sab-users',
      path: `${APP_PREFIX_PATH}/sab/users`,
      title: 'User Management',
      icon: UserOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.USERS, action: 'read' }
    },
    {
      key: 'sab-file-manager',
      path: `${APP_PREFIX_PATH}/sab/file-manager`,
      title: 'File Manager',
      icon: FolderOpenOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.DOCUMENTS, action: 'read' },
    },
    {
      key: 'sab-backups',
      path: `${APP_PREFIX_PATH}/sab/backups`,
      title: 'Backup & Restore',
      icon: CloudServerOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.BACKUPS, action: 'read' }
    },
    {
      key: 'sab-website-settings',
      path: `${APP_PREFIX_PATH}/sab/website-settings`,
      title: 'Website Settings',
      icon: GlobalOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.WEBSITE_SETTINGS, action: 'read' }
    },
    {
      key: 'sab-gallery',
      path: `${APP_PREFIX_PATH}/sab/gallery`,
      title: 'Photo Gallery',
      icon: PictureOutlined,
      breadcrumb: false,
      submenu: [],
      permission: { resource: RESOURCES.GALLERY, action: 'read' }
    }
  ]
}];

const navigationConfig = [
  ...displayControlNavTree,
  ...eventsNavTree,
  ...financesNavTree,
  ...adminNavTree,
]

export default navigationConfig;
